import React from 'react';
import { isPreviewable } from '../../../../../services/attachmentService';
import { formatFileSize } from '../../../../SprintDetail/shared/AttachmentsModal/utils/formatters';
import { inferFileType } from '../../../utils/fileOverrides';
import {
  ActionIcon,
  DownloadIcon,
  EyeIcon,
  PlayGlyph,
  ReplaceIcon,
  TrashIcon,
  TypeGlyph,
} from './FileUploadIcons';

export const FileUploadFileRow = ({
  file,
  canUpload,
  onView,
  onDownload,
  onReplace,
  onRemove,
}) => {
  const fileType = inferFileType(file.mimeType, file.filename, file.fileType);
  const canView = isPreviewable(fileType);
  const thumbSrc = file.thumbDataUrl;

  return (
    <li className="file-upload-block__file">
      <button
        type="button"
        className={`file-upload-block__thumb${thumbSrc ? ' is-image' : ''}`}
        onClick={() => canView && onView(file)}
        disabled={!canView}
        title={canView ? 'View' : file.filename}
      >
        {thumbSrc ? <img src={thumbSrc} alt="" /> : <TypeGlyph fileType={fileType} />}
        {fileType === 'video' && thumbSrc ? (
          <span className="file-upload-block__play" aria-hidden>
            <PlayGlyph />
          </span>
        ) : null}
      </button>
      <span className="file-upload-block__meta">
        <span
          className="file-upload-block__file-name"
          title={`${file.filename} · ${formatFileSize(file.size)}`}
        >
          {file.filename}
        </span>
        <span className="file-upload-block__file-size">{formatFileSize(file.size)}</span>
      </span>
      <span className="file-upload-block__actions is-visible">
        {canView ? (
          <ActionIcon title="View" onClick={() => onView(file)}>
            <EyeIcon />
          </ActionIcon>
        ) : null}
        <ActionIcon title="Download" onClick={() => onDownload(file)}>
          <DownloadIcon />
        </ActionIcon>
        {canUpload ? (
          <ActionIcon title="Replace" onClick={onReplace}>
            <ReplaceIcon />
          </ActionIcon>
        ) : null}
        {canUpload ? (
          <ActionIcon title="Delete" danger onClick={() => onRemove(file.attachmentId)}>
            <TrashIcon />
          </ActionIcon>
        ) : null}
      </span>
    </li>
  );
};
